import appColors from 'theme/appColors';
import { appBorderRadius, appBreakPoints } from 'theme/sizes';

const AppBoxStyles = {
  variants: {
  },
};

export default AppBoxStyles;
